import { useState } from "react";
import { renderAmount } from "../../utils/formatting";
import ActionButton from "../common/action-button/ActionButton";
import InputAmountMint from "../common/input-amount/InputAmountMint";
import InputMaxButtonMint from "../common/input-max-button/InputMaxButtonMint";
import { RedemptionAction } from "./Redemption";

type Props = {
  setRedemptionAction: (action: RedemptionAction) => void;
  handleBurn: (amount: number) => Promise<void>;
  calculateClaimableUSDCAmountPhaseOne: (uctAmount: number) => number;
};
export default function Burn({
  setRedemptionAction,
  handleBurn,
  calculateClaimableUSDCAmountPhaseOne,
}: Props) {
  const connected = true;

  const [amount, setAmount] = useState("");
  const [usdcAmount, setUsdcAmount] = useState(0);
  const calculateUsdcAmount = (val: string) => {
    setAmount(val);
    setUsdcAmount(calculateClaimableUSDCAmountPhaseOne(Number(val)));
  };
  const UCT = window.__UXD__.solana.config.getMintInfo("UCT");

  const claimable = false;

  const toggleAction = () => {
    setRedemptionAction(RedemptionAction.Redeem);
  };

  const doBurn = async (amount: number) => {
    await handleBurn(amount);
    setAmount("");
  };

  return (
    <>
      <div className="Redemption-Title">
        <h2>Burn UCT into USDC</h2>
        <p>Convert your UCT tokens into USDC.</p>
      </div>
      <div className="Redemption-Input">
        <div className="Redemption-Content-Detail">
          <label htmlFor="amount-input">Burn UCT</label>
          <InputMaxButtonMint
            activeMint={UCT}
            handleClick={
              !claimable
                ? (amount: string) => {
                    calculateUsdcAmount(amount);
                  }
                : undefined
            }
          />
        </div>

        <InputAmountMint
          id="amount-input"
          name="amount"
          amount={amount}
          handleChange={calculateUsdcAmount}
          disabled={false}
          reset={connected}
          mint={window.__UXD__.solana.config.getMintInfo("UCT")}
        />
        <div className="Redemption-Content-Detail">
          <div>Expected USDC</div>
          <div>
            {renderAmount(usdcAmount, { currency: "usdc", decimals: 6 })}
          </div>
        </div>
      </div>

      <div className="Redemption-Action">
        <ActionButton
          color="orange"
          label={"Burn"}
          disabled={!connected || !amount || Number(amount) === 0}
          form={"Redemption"}
          type="submit"
          onClick={() => doBurn(Number(amount))}
        />
      </div>

      <div className="Redemption-Navigation">
        Redeem UXP into UCT{" "}
        <a href="#!" onClick={toggleAction}>
          here
        </a>
        .
      </div>
    </>
  );
}
